// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".ad-preview-wrapper {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n}\n\n.ad-preview-wrapper.reports {\n  max-height: 420px; \n}\n\n.ad-preview-wrapper.reports.FACEBOOK_STORY_MOBILE, .ad-preview-wrapper.reports.INSTAGRAM_STORY {\n  max-height: 450px; \n}\n\n.ad-preview-wrapper.reports > iframe {\n  transform: scale(0.8);\n}\n\n.preview-select.reports {\n  margin-top: 2rem;\n}", ""]);
// Exports
module.exports = exports;
